import { Button } from '@/design-system/components/Button/Button'
import { mergeClassNames } from '@/design-system/lib/mergeClassNames'
import { paginationSummary } from './paginationSummary'

export interface PaginationProps {
  /** Page courante, à partir de 1. */
  page: number
  pageSize: number
  total: number
  onPageChange: (page: number) => void
  /** Nom des éléments au pluriel, dans le résumé « 1–25 sur 80 routes ». */
  itemLabel?: string
  className?: string
}

/**
 * Pied de liste paginée : résumé à gauche, Précédent / Suivant à droite. Reprend le gabarit `master-pagination`
 * jusque-là recopié par chaque liste.
 */
export function Pagination({
  page,
  pageSize,
  total,
  onPageChange,
  itemLabel = 'éléments',
  className,
}: PaginationProps) {
  const pageCount = Math.max(1, Math.ceil(total / pageSize))
  return (
    <nav className={mergeClassNames('master-pagination', className)} aria-label="Pagination">
      <span aria-live="polite">{paginationSummary(page, pageSize, total, itemLabel)}</span>
      <div>
        <Button
          size="small"
          disabled={page <= 1}
          onClick={() => {
            onPageChange(page - 1)
          }}
        >
          Précédent
        </Button>
        <span>
          Page {page} sur {pageCount}
        </span>
        <Button
          size="small"
          disabled={page >= pageCount}
          onClick={() => {
            onPageChange(page + 1)
          }}
        >
          Suivant
        </Button>
      </div>
    </nav>
  )
}
